import React, { useContext, useState } from 'react';
import HighlightedOffer from './offer/highlighted-offer';
import { HighlightedOfferPanel, HighlightWrapper } from './styles';
import { HighlightedOfferType, IHighlightedOffersProps } from './types';
import { AppContext } from '@prisjakt/ui-app-context';
import { HighlightOfferType } from 'src/hooks/experiments';
import PromotedOfferRow from '../price-list/price-row/row-types/promoted';
import { PriceDisplayEnum } from '../../types';
import HighlightedOfferAndPromotedExperiment from './experiment/experimentHighlightAndPromote';
import HighlightOfferExperiment from './experiment/experimentHighlightOffer';

const HighlightedOffers: React.FC<IHighlightedOffersProps> = props => {
  const [showHighlightedOffers, setShowHighlightedOffers] = useState<
    HighlightOfferType
  >(false);
  const { t } = useContext(AppContext);

  const cheapest =
    props.priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
      ? props.highlights?.cheapest?.inclShipping
      : props.highlights?.cheapest?.exclShipping;

  const showPromotedOffer = showHighlightedOffers === 'promoted';

  const promotedRow =
    props.highlights?.promoted &&
    (showHighlightedOffers === 'promotedlarge' ||
      showHighlightedOffers === 'promotedonly');

  const highlightsExist =
    props.highlights?.best ||
    props.highlights?.cheapest ||
    props.highlights?.fastest;

  const highlightOrPromoExist = highlightsExist || props.highlights?.promoted;

  const showHighlightedOfferPanel =
    showHighlightedOffers &&
    showHighlightedOffers !== 'promotedonly' &&
    highlightsExist;

  return (
    <>
      <HighlightedOfferAndPromotedExperiment
        categoryId={props.categoryId}
        setShowHighlightedOffers={setShowHighlightedOffers}
      />
      <HighlightOfferExperiment
        categoryId={props.categoryId}
        setShowHighlightedOffers={setShowHighlightedOffers}
      />
      {showHighlightedOffers && highlightOrPromoExist && (
        <HighlightWrapper>
          {showHighlightedOfferPanel && (
            <HighlightedOfferPanel>
              {props.highlights.best && (
                <HighlightedOffer
                  title={t('product', 'price.recommended')}
                  subtitle={t('product', 'price.recommended-description')}
                  productId={props.productId}
                  priceDisplay={props.priceDisplay}
                  campaign={props.campaign}
                  offer={props.highlights.best}
                  type={HighlightedOfferType.Recommended}
                />
              )}
              {!showPromotedOffer && cheapest && (
                <HighlightedOffer
                  title={t('product', 'price.affordable')}
                  subtitle={t('product', 'price.affordable-description')}
                  productId={props.productId}
                  priceDisplay={props.priceDisplay}
                  campaign={props.campaign}
                  offer={cheapest}
                  type={HighlightedOfferType.Cheapest}
                />
              )}
              {showPromotedOffer && props.highlights?.promoted && (
                <HighlightedOffer
                  title={t('product', 'price.promoted')}
                  subtitle={t('product', 'price.promoted-description')}
                  productId={props.productId}
                  priceDisplay={props.priceDisplay}
                  campaign={props.campaign}
                  offer={props.highlights?.promoted}
                  type={HighlightedOfferType.Promoted}
                />
              )}
            </HighlightedOfferPanel>
          )}
          {promotedRow && (
            <PromotedOfferRow
              productId={props.productId}
              priceDisplay={props.priceDisplay}
              campaign={props.campaign}
              offer={props.highlights.promoted!}
              type={
                showHighlightedOffers === 'promotedlarge'
                  ? HighlightedOfferType.PromotedLarge
                  : HighlightedOfferType.PromotedStandalone
              }
            />
          )}
        </HighlightWrapper>
      )}
    </>
  );
};

export default HighlightedOffers;
